import { Col, Form, Input, InputNumber, Modal, notification, Row } from 'antd';
import { useEffect, useState } from 'react';
import { apiWms } from '../../../../../../shared/api';
import errorHandler from '../../../../../../shared/utils/errorHandler';

const WarehouseEditModal = ({ isModalVisible, setModalVisible, warehouseId }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	const onFinishForm = async () => {
		const formValues = await form.validateFields();

		try {
			const res = await apiWms.put('/warehouse/update', {
				...formValues,
				warehouseId
			});

			if (res.status === 200) {
				setModalVisible(false);
				notification.success({
					message: 'Success',
					description: 'Warehouse updated successfully',
					placement: 'topRight'
				});
			}
		} catch (err) {
			errorHandler(err);
		}
	};
	const closeModal = () => setModalVisible(false);

	const fetchWarehouseById = async () => {
		try {
			setIsLoading(true);
			const { data } = await apiWms.get(`/warehouse/profile/${warehouseId}`);
			const profile = data.profile;

			form.setFieldsValue({
				name: profile?.name,
				pincode: profile?.pincode,
				line1: profile?.addressLine1,
				line2: profile?.addressLine2,
				city: profile?.city,
				state: profile?.state,
				country: profile?.country,
				phone: profile?.phone,
				latitude: profile?.coordinate?.coordinates[0],
				longitude: profile?.coordinate?.coordinates[1],
				landmark: profile.landmark
			});
		} catch (err) {
			console.log(err, 'Error in fetching warehouse by Id');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (isModalVisible && warehouseId) {
			fetchWarehouseById();
		}
	}, [isModalVisible, warehouseId]);

	return (
		<Modal
			title="Update Warehouse"
			visible={isModalVisible}
			onCancel={closeModal}
			confirmLoading={isLoading}
			okText="Submit"
			onOk={() => form.submit()}
			width={800}
		>
			<Form form={form} layout="vertical" onFinish={onFinishForm}>
				<Row gutter={80}>
					<Col sm={12} lg={12}>
						<Form.Item name="name" label="Name">
							<Input placeholder="Enter warehouse name" />
						</Form.Item>

						<Form.Item name="pincode" label="Pincode">
							<Input placeholder="Enter pincode" />
						</Form.Item>

						<Form.Item name="line1" label="AddressLine1">
							<Input placeholder="Enter address line 1" />
						</Form.Item>

						<Form.Item name="line2" label="AddressLine2">
							<Input placeholder="Enter address line 2" />
						</Form.Item>

						<Form.Item name="latitude" label="Latitude">
							<InputNumber placeholder="28.33" style={{ width: '100%' }} />
						</Form.Item>
						<Form.Item name="landmark" label="Landmark">
							<InputNumber placeholder="Enter landmark" style={{ width: '100%' }} />
						</Form.Item>
					</Col>
					<Col lg={12}>
						<Form.Item name="city" label="City">
							<Input placeholder="Enter city" />
						</Form.Item>

						<Form.Item name="state" label="State">
							<Input placeholder="Enter state" />
						</Form.Item>

						<Form.Item name="country" label="Country">
							<Input placeholder="Enter country" />
						</Form.Item>

						<Form.Item name="phone" label="Phone">
							<Input placeholder="Enter phone number" />
						</Form.Item>

						<Form.Item name="longitude" label="Longitude">
							<InputNumber placeholder="77.44" style={{ width: '100%' }} />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default WarehouseEditModal;
